import { useEffect } from 'react';

import { useGetCompanyQuery } from '../../../api/lendingApi/lendingApiQueries';
import RouteSpinner from '../../RouteSpinner/RouteSpinner';
import GetStartedUK from '../GetStartedUK/GetStartedUK';

type TProps = {
  handleStateUpdateError: (error: Error) => void;
};

const GetStartedWithPrefillUK = ({ handleStateUpdateError }: TProps) => {
  const { company, isLoadingCompany } = useGetCompanyQuery();

  // temporary effect to redirect paytek customers as they included a link to sandbox in an email campaign
  useEffect(() => {
    if (
      window.location.href?.includes(
        'stage.iwoca-dev.co.uk/partner-signup/paytek',
      )
    )
      window.location.href = 'https://iwoca.co.uk/partner-signup/paytek';
  }, []);

  if (isLoadingCompany) {
    return <RouteSpinner />;
  }

  return (
    <GetStartedUK
      company={company}
      handleStateUpdateError={handleStateUpdateError}
    />
  );
};

export default GetStartedWithPrefillUK;
